import {map} from 'rxjs/operators';

export class UpdateAdvisingHeaderTaskRequest {
  adNo?: string
  taskCode?: string[]
  taskRemark: string | null
  createUser?: string
  updateUser?: string
  carbonCopyUsers?: string[]
  advanceTaskRemark?: { [p: string]: any } | null

  constructor(){
    this.adNo = undefined
    this.taskCode = undefined
    this.taskRemark = null
    this.createUser = undefined
    this.updateUser = undefined
    this.carbonCopyUsers = undefined
    this.advanceTaskRemark = undefined
  }
}
